module.exports = "/_next/static/images/5651ee1f0de8cbb11e0d81becbb703f6-card-background-left-xs.jpg.webp";